import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const xrlivePreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '{rose.50}',
            100: '{rose.100}',
            200: '{rose.200}',
            300: '{rose.300}',
            400: '{rose.400}',
            500: '{rose.500}',
            600: '{rose.600}',
            700: '{rose.700}',
            800: '{rose.800}',
            900: '{rose.900}',
            950: '{rose.950}'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '{rose.950}',
                    contrastColor: '{rose.300}',
                    hoverColor: '{rose.900}',
                    activeColor: '{rose.800}'
                },
                highlight: {
                    background: '{rose.950}',
                    focusBackground: '{rose.700}',
                    color: '{rose.300}',
                    focusColor: '{rose.300}'
                }
            },
            dark: {
                primary: {
                    color: '{rose.50}',
                    contrastColor: '{rose.950}',
                    hoverColor: '{rose.400}',
                    activeColor: '{rose.500}'
                },
                highlight: {
                    background: '{rose.950}',
                    focusBackground: '{rose.700}',
                    color: '{rose.300}',
                    focusColor: '{rose.300}'
                }
            }
        }
    }
});

export default xrlivePreset;